import React, { useState } from "react";
import { LikeOutlined, DislikeOutlined, CopyTwoTone } from "@ant-design/icons";
import { Button } from "antd";

const ReadMoreText = ({
  messageObj,
  text,
  onThumbsUp,
  onThumbsDown,
  handleCopyMessage,
  isLiked,
  isDisLiked,
  maxLength = 150,
}) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [speakingState, setSpeakingState] = useState({});

  const toggleText = () => setIsExpanded((prev) => !prev);

  const isTruncated = text.length > maxLength;

  const readAloud = (text, messageKey) => {
    if (!window.speechSynthesis) {
      alert("Text-to-Speech is not supported in this browser.");
      return;
    }

    if (speakingState[messageKey]) {
      window.speechSynthesis.cancel();
      setSpeakingState((prevState) => ({
        ...prevState,
        [messageKey]: false,
      }));
      return;
    }

    const utterance = new SpeechSynthesisUtterance(text);
    utterance.onend = () => {
      setSpeakingState((prevState) => ({
        ...prevState,
        [messageKey]: false,
      }));
    };
    window.speechSynthesis.speak(utterance);
    setSpeakingState((prevState) => ({
      ...prevState,
      [messageKey]: true,
    }));
  };

  const handleMicClick = (message) => {
    const contentToRead = [message]
      .filter(Boolean) // Remove any undefined or null values
      .join(". "); // Join the values with a period and space
    const messageKey = `${message}`; // Generate a unique key
    readAloud(contentToRead, messageKey);
  };

  // Function to format the message
  const formatDynamicHighlights = (message) => {
    // Highlight monetary values, percentages, and numbers
    let formattedMessage = message
      .replace(
        /(\$\d+(\.\d+)?|€\d+(\.\d+)?|\d+(\.\d+)?%?)/g,
        '<strong style="color: blue;">$1</strong>'
      )
      .replace(
        /\b(\d{1,2}\/\d{1,2}\/\d{4}|\d{4}-\d{1,2}-\d{1,2})\b/g,
        '<strong style="color: blue;">$1</strong>'
      );

    // Convert ordered lists
    formattedMessage = formattedMessage
      .replace(/(^|\n)(\d+\.)\s+/g, "$1<ol><li>")
      .replace(/<\/li>(?!<\/ol>)/g, "</li></ol>");

    // Convert unordered lists
    formattedMessage = formattedMessage
      .replace(/(^|\n)([-*])\s+/g, "$1<ul><li>")
      .replace(/<\/li>(?!<\/ul>)/g, "</li></ul>");

    // Wrap paragraphs
    const paragraphs = formattedMessage
      .split(/\n{2,}/) // Split by double line breaks
      .map((paragraph) => paragraph.trim())
      .filter((paragraph) => paragraph.length > 0) // Remove empty paragraphs
      .map((paragraph) => `<p>${paragraph}</p>`)
      .join("");

    return paragraphs;
  };

  const formattedText = formatDynamicHighlights(text); // Format the text with highlights

  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      <span
        style={{
          display: "inline",
          wordBreak: "break-word",
          whiteSpace: "normal",
        }}
      >
        <span
          className="danger_text"
          dangerouslySetInnerHTML={{
            __html:
              isTruncated && !isExpanded
                ? `${formattedText.slice(0, maxLength)}...`
                : formattedText,
          }}
        ></span>
      </span>
      {/* Other icons/buttons should remain on a separate line */}
      <div style={{ marginTop: "5px", textAlign: "right" }}>
        {isTruncated && (
          <Button
            Button
            type="link"
            onClick={toggleText}
            style={{
              color: "blue",
              cursor: "pointer",
              border: "none",
              background: "none",
              //   paddingLeft: "5px",
              padding: 0,
              whiteSpace: "nowrap",
              float: "left",
            }}
          >
            {isExpanded ? "Read Less" : "Read More"}
          </Button>
        )}
        <LikeOutlined
          className={`feedback-icon thumbs-up ${isLiked ? "clicked" : ""}`}
          onClick={() => onThumbsUp(messageObj)}
          title="Good Response"
        />
        <DislikeOutlined
          className={`feedback-icon thumbs-down ${isDisLiked ? "clicked" : ""}`}
          onClick={() => onThumbsDown(messageObj)}
          title="Bad Response"
        />
        <CopyTwoTone
          className="feedback-icon copy"
          onClick={() => handleCopyMessage(text)}
          title="Copy"
        />
        <button
          className="tts-button"
          title="Read Aloud"
          onClick={() => handleMicClick(text)}
        >
          {speakingState[`${text}`] ? "⏹️" : "🔊"}
        </button>
      </div>
    </div>
  );
};

export default ReadMoreText;
